import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import rim from "../assets/img/rim.jpg";
import img1 from "../assets/img/bandeau.jpg";

export const Auteure = () => {

  return (
    <div className='auteure-container'>

      <div className="banner-titre-container">
        <img src={img1} className="back-img" />
        <div className='over-banner'>
          <div className='info-banner'>
            <h1 className='banner-title'> Rim-la-Belle et son monde merveilleux</h1>
          </div>
        </div>
      </div>
      
      <br/>
      <br/>

      <h4 className='faq-titre faq-titre-container'>
        Pour initier les enfants aux merveilles du monde qui nous entoure, j'ai écrit un conte musical illustré. Le projet est actuellement en recherche d'éditeur. Sa version électronique ainsi que les chansons sont  disponibles sur demande.
      </h4>

      <div className='single-container auteure-single-container bottom-space '><br/>
        <Row>

          <Col xs={12} md={5}>

            <div className="auteure-img-container">
              <img src={rim} alt="" className="auteure-img" />
            </div>
            <p className='auteure-content small-auteure'><strong>Collection de livres-CD pour s'éveiller et grandir dans la joie</strong></p>
            <div className='bouton-rectangle-container'>
              <Link to={'/contact'} className='bouton-rectangle-rim'>
                Me contacter
              </Link>
            </div>
          </Col>
          <Col xs={12} md={7}>
            <p className='auteure-content'>

              Rim-la-Belle et son monde merveilleux est la découverte de la Nature et de la Vie à travers les yeux<br />
              d'une  enfant. Parfaitement heureuse, Rim-la-Belle pose un regard joyeux,<br />
              plein de candeur sur son environnement, nous révélant ainsi le sens caché des choses. <br /><br />
              "Le monde est simplement merveilleux"...  <br /><br />
              ... telle est la devise de Rim-la-Belle, accompagnée dans ses aventures par de précieux alliés : <br />
              Flora-la-Fleur, Sergio-le-Singe, Tonton-musicien-à-la-casquette, <br />
              Tata-chanteuse-aux-cheveux-longs et Prosper, son savant ami. <br /><br />
              Avec Rim-la-Belle, nous apprenons à écouter la sagesse de notre propre coeur et à vivre en harmonie<br />
              avec ceux qui nous entourent, si différents et pourtant si semblables. Nous apprenons à nous relier à<br />
              notre Mère, la Terre, et à communiquer avec les animaux, la nature, les fleurs, les arbres, les cristaux...<br />
              et même avec ceux qui nous ont quittés.  <br /><br />
              Avec ses messages clairs, légers et profonds à la fois, la Collection Rim-la-Belle offre des réponses<br />
              et clés aux enfants en soif de compréhension, en plus de les conforter dans leurs propres ressentis.  <br /><br />
              Chaque thème est ensuite repris dans une chanson que l'enfant peut suivre <br />
              sur des portées musicales où chaque note a sa couleur. <br /><br />
              Mots, images, mélodies et musiques agissent telles des berceuses apaisantes et rassurantes qui permettent à l'enfant de se poser.
              <br /><br />Un Univers ... magique ? Oui !<br />
              Et, bonne nouvelle, il n'est autre que celui dans lequel nous vivons.  <br /><br />
              Pour enfants, petits et grands, à partir du ...  1er battement de coeur <br /><br />

            </p>

          </Col>
        </Row>
      </div>
    </div>
  );
}

